import { apiClient } from '@/shared/lib/api/client';
import type { NotificacoesPagina, NotificacoesResumo } from './notificacaoTypes';

export const notificacaoService = {
  listar: async (params?: {
    cursor?: string;
    tamanho?: number;
    naoLidas?: boolean;
  }): Promise<NotificacoesPagina> => {
    const query: Record<string, string | number | boolean> = {};
    if (params?.cursor) query.cursor = params.cursor;
    if (params?.tamanho != null) query.tamanho = params.tamanho;
    if (params?.naoLidas != null) query.naoLidas = params.naoLidas;
    const { data } = await apiClient.get<NotificacoesPagina>('/v1/notificacoes', {
      params: Object.keys(query).length ? query : undefined,
    });
    return data;
  },

  resumo: async (): Promise<NotificacoesResumo> => {
    const { data } = await apiClient.get<NotificacoesResumo>('/v1/notificacoes/resumo');
    return data;
  },

  marcarLida: async (id: number): Promise<void> => {
    await apiClient.post(`/v1/notificacoes/${id}/lida`);
  },

  marcarTodasLidas: async (): Promise<void> => {
    await apiClient.post('/v1/notificacoes/lidas');
  },
};
